"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkCommentDialog = void 0;
const react_1 = __importStar(require("react"));
const predicate_language_1 = require("@groupby/predicate-language");
const ui_components_1 = require("@groupby/ui-components");
const bulk_commenting_dialog_styles_1 = require("./bulk-commenting-dialog.styles");
const partials_1 = require("../partials");
const hooks_1 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const BulkCommentDialog = ({ selectedCount, activeFilter, onClose, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addError } = (0, hooks_1.useNotification)();
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const handleClose = () => onClose(false);
    const client = (0, hooks_1.useEnrichClient)();
    const isExclusionModeOn = (0, store_1.useIsExclusionModeOn)();
    const selectedProductIds = (0, store_1.useSelectedProductIds)();
    const handleSubmit = (comment) => __awaiter(void 0, void 0, void 0, function* () {
        setIsSubmitting(true);
        let productIds = selectedProductIds;
        if (isExclusionModeOn) {
            productIds = (0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '!@<', selectedProductIds.map(predicate_language_1.uuid));
        }
        try {
            yield client.comments.createOne({ content: comment, subjectIds: productIds });
            onClose(true);
        }
        catch (e) {
            addError(t({ key: 'COMMENT_CREATE_ERROR' }));
            throw new Error(e.message);
        }
        finally {
            setIsSubmitting(false);
        }
    });
    return (react_1.default.createElement(ui_components_1.Dialog, { open: true, maxWidth: "sm", title: react_1.default.createElement(partials_1.DialogTitle, { title: t({ key: 'BULK_COMMENTING_DIALOG_TITLE' }), onClose: handleClose }) }, react_1.default.createElement(bulk_commenting_dialog_styles_1.StyledDialogContent, null, react_1.default.createElement(bulk_commenting_dialog_styles_1.StyledProductList, { expanded: isExpanded, setExpanded: setIsExpanded, productsCount: selectedCount, activeFilter: activeFilter }), react_1.default.createElement(partials_1.CommentTextBox, { isSubmitting: isSubmitting, onSubmit: handleSubmit }))));
};
exports.BulkCommentDialog = BulkCommentDialog;
exports.default = exports.BulkCommentDialog;
